<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :fullscreen="true"
    :ok-disabled="disableSubmit"
    :cancelText="language['common.closeButton']">
    <cms-content-tbl-form ref="realForm" v-if="colTemplateType=='1'||colTemplateType=='2'||colTemplateType=='4'||colTemplateType=='8'" @ok="submitCallback" :disabled="disableSubmit" :colidProps="this.colid" :pageLangCode="pageLangCode" :contentPath="this.contentPath"></cms-content-tbl-form>
    <cms-content-tbl-form3 ref="realForm" v-if="colTemplateType=='3'" @ok="submitCallback" :disabled="disableSubmit" :colidProps="this.colid" :pageLangCode="pageLangCode" :contentPath="this.contentPath"></cms-content-tbl-form3>
    <cms-content-tbl-form5 ref="realForm" v-if="colTemplateType=='5'" @ok="submitCallback" :disabled="disableSubmit" :colidProps="this.colid" :pageLangCode="pageLangCode" :contentPath="this.contentPath"></cms-content-tbl-form5>
    <cms-content-tbl-form6 ref="realForm" v-if="colTemplateType=='6'" @ok="submitCallback" :disabled="disableSubmit" :colidProps="this.colid" :pageLangCode="pageLangCode" :contentPath="this.contentPath"></cms-content-tbl-form6>
  </j-modal>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import CmsContentTblForm from './CmsContentTblForm';
  import CmsContentTblForm3 from './CmsContentTblForm3'
  import CmsContentTblForm5 from './CmsContentTblForm5'
  import CmsContentTblForm6 from './CmsContentTblForm6'
  export default {
    name: 'CmsContentTblModal',
    components: {
      CmsContentTblForm,
      CmsContentTblForm3,
      CmsContentTblForm5,
      CmsContentTblForm6
    },
    props: {
      colid: String,
      pageLangCode:String,
    },
    data () {
      return {
        title:'',
        width:1200,
        visible: false,
        disableSubmit: false,
        colTemplateType:'0',
        contentPath:"",
      }
    },created() {
      getAction("/hhemp/col/cmscoltbl/"+this.colid).then(res=> {
        if (res.success) {
          let col = res.result;
          this.colTemplateType = col.topTemplateType;
          this.contentPath = col.entranceName+">"+col.colPath;
          /*if(col.templateType){
            this.colTemplateType = col.templateType;
          }else{
            this.colTemplateType = col.parent.templateType
          }*/
        }
      })
    },
    computed: {
      language() {
        return this.$store.getters.language
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>